import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'assign-to-users',
  templateUrl: './assign-to-users.component.html',
  styleUrls: ['./assign-to-users.component.scss']
})
export class AssignToUsersComponent implements OnInit {
 @Input() selMenu: string = 'users';
  public totalMembers: Array<any> = [];
  public membersType: Array<any> = [];
  public roleList: any = [];
  public selected: any = null;
  public commonModal: any;
  public form: FormGroup = new FormGroup({
    id: new FormControl("", [Validators.required]),
    name: new FormControl("", [Validators.required]),
    type: new FormControl("DEFAULT", [Validators.required]),
    description: new FormControl(null, [Validators.required]),
    price: new FormControl(null),
  });

  public imgUrl = environment.ImageUrl;
  public imageBase64: string | ArrayBuffer;
  public image: any;
  
  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getUpdateData();
  }

  public getUpdateData() {
    this._userTypeList();
    this._getAllRoleList();
  }

  private _userList(): void {
    this.auth.getAllUser().subscribe((response: ApiResponse) => {
      this.totalMembers = response?.body || [];
    });
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
    this.getUpdateData();
  }

  private _userTypeList(): void {
    this.auth.getAllMemberUserTypeRelationship().subscribe((response: ApiResponse) => {
      this.membersType = response?.body || [];
      this._userList();
    });
  }

  private _getAllRoleList() {
    this.auth.getAllMemberRole().subscribe((resp: ApiResponse) => {
      this.roleList = resp.body;
    })
  }

  public add(modal: any, selected: any = null) {
    if (selected) {
      this.form.patchValue({
        id: selected?.userTypeId,
        name: selected?.userTypeName,
        description: selected?.description,
        type: selected?.type,
        price: selected?.price,
      })
      this.selected = selected;
      this.image = selected?.image;
    } else {
      this.selected = null;
      this.form.reset();
      this.form.get("type").setValue("DEFAULT");
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public addRoleToUserType(userTypeId, currentRoleList) {
    if (this.selected) {
      if (currentRoleList.filter((i) => i.roleId == this.selected && i.userTypeId == userTypeId).length > 0) {
        this.toastr.error("Role Already Present!");
      } else {
        this.auth.addMemberUserTypeRelationship({ roleId: this.selected, userTypeId: userTypeId }).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.getUpdateData();
          this.selected = null;
        }, (error: any) => {
          this.toastr.error("Error Please try again!");
        });
      }
    } else {
      this.toastr.error("Select Permissions !");
    }
  }

  public addUserTypeToUser(userId, currentUserTypeList) {
    if (this.selected) {
      if (currentUserTypeList.filter((i) => i.userTypeId == this.selected && i.userId == userId).length > 0) {
        this.toastr.error("User Type Already Present!");
      } else {
        this.auth.addMemberToUserTypes({ userTypeId: this.selected, userId: userId }).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.getUpdateData();
          this.selected = null;
        }, (error: any) => {
          this.toastr.error("Error Please try again!");
        });
      }
    } else {
      this.toastr.error("Select User Type!");
    }
  }

  public addSubmit() {

    if (this.roleList.filter((i) => i.userTypeName == this.form.get("name").value).length > 0) {
      this.toastr.error("User Type Already Present!");
    }

    let formData = new FormData();
    formData.append("userTypeName",this.form.get("name").value.toUpperCase());
    formData.append("description",this.form.get("description").value || '');
    formData.append("type",this.form.get("type").value.toUpperCase());
    formData.append("price",this.form.get("price").value);
    typeof this.image == "string" ? "" : formData.append("image", this.image);

    if (this.selected) {
       formData.append("userTypeId",this.form.get("id").value);
    }

    this.auth.addMemberUserTypes(formData).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this._userTypeList();
      this.selected = null;
      this.image = '';
      this.imageBase64 = null;
    }, (error: any) => {
      this.toastr.error("Error Please try again!");
    })
  }


  public deleteItem(id: any) {
    this.auth.deleteMemberUserTypes(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getUpdateData();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public deleteMemberTypeRelationship(id: any) {
    this.auth.deleteMemberUserTypeRelationship(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getUpdateData();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public onRoleChange(value) {
    this.selected = value;
  }

  public changeUserRole(userId: any, userTypeId, currentUserType) {
    this.auth.addMemberToUserTypes({ userId: userId, userTypeId: userTypeId }).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getUpdateData();
      this.selected = null;
    }, (error: any) => {
      this.toastr.error("Error Please try again!");
    })
  }

  public removeMemberUserTypes(id: any) {
    this.auth.deleteMemberToUserTypes(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getUpdateData();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public saveProductCharSelectedImage(event) {
    this.selected ? (this.selected.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.image = file;
    };
    fileReader.readAsDataURL(file);
  }

}
